import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./i18n";
import "./index.css";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import FloatingWhatsapp from "./components/FloatingWhatsapp";
import Admin from "./pages/Admin";

import useHeaderScroll from "./hooks/useHeaderScroll";
import useRevealOnScroll from "./hooks/useRevealOnScroll";
import useSlider from "./hooks/useSlider";

const WA_NUMBER = "919486260006";

const App = () => {
  const { t } = useTranslation();
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/" element={<Home t={t} />} />
      </Routes>
    </Router>
  );
};

const Home = ({ t }) => {
  // Hooks
  const headerScrolled = useHeaderScroll(40);
  useRevealOnScroll();
  const slidesRef = useSlider(3500);

  // Contact form state
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [service, setService] = useState("Consultation - Specific Problem");
  const [date, setDate] = useState("");
  const [notes, setNotes] = useState("");

  // WhatsApp helpers
  const openWhatsApp = (prefMessage) => {
    const url = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
      prefMessage
    )}`;
    window.open(url, "_blank");
  };

  const handleBook = () => {
    const message = `Hello Mr. Kannan! I would like to book a consultation.
Name: ${name}
Phone: ${phone}
Service: ${service}
Preferred date: ${date || "Any"}
Notes: ${notes}`;
    openWhatsApp(message);
  };

  const handleCall = () => {
    window.location.href = "tel:+919486260006";
  };

  const handleWaFloat = () => {
    openWhatsApp(
      "Hello Mr. Kannan, I would like to enquire about a consultation."
    );
  };

  return (
    <>
      <div className="container">
        <Header scrolled={headerScrolled} />

        <main>
          <Hero onBook={handleBook} onCall={handleCall} />
          <Services />
          <Testimonials slidesRef={slidesRef} />
          <AboutSection />
          <ContactSection
            name={name}
            phone={phone}
            service={service}
            date={date}
            notes={notes}
            onNameChange={setName}
            onPhoneChange={setPhone}
            onServiceChange={setService}
            onDateChange={setDate}
            onNotesChange={setNotes}
            onBook={handleBook}
            onCall={handleCall}
          />
        </main>

        <footer>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <div>
              <strong>{t('header.brand')}</strong> • {t('header.subtitle')}
            </div>
            <div style={{ color: "var(--muted)" }}>
              {t('footer.rights', { year: new Date().getFullYear() })}
            </div>
          </div>
        </footer>
      </div>

      <FloatingWhatsapp onClick={handleWaFloat} />
    </>
  );
};

export default App;
